const constants = {
  SESSION_EXPIRED: 'session_expired',
  SESSION_WILL_EXPIRE: 'session_will_expire',
  SESSION_TIMER_INTERVAL: 30000,
  
  // Authentication providers
  AUTH_PROVIDER_AMAZON: 'AmazonFederate',
  AUTH_PROVIDER_LASSO: 'LASSO',
};

export default constants;
